export default __webpack_public_path__ + "static/media/preview-ghs.1feb77a5.jpg";